import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/deals/[id]/detail/Page";

export const PATH = (id: number): string => `/vendors/deals/${id}/detail`;

const DealsDetail: NextPage = () => (
	<>
		<NskHead title="案件内容" />
		<Component />
	</>
);

export default DealsDetail;
